import React from "react";
import { useActiveFilters, useFilter, useFilterSync } from "web/react/hooks/filters";
import { useFilterBack } from "web/react/hooks/filters/use-filter-back";
import { FilterDialogScreen } from "./filter-dialog/filter-dialog-screen";
import { MenuItemCheckbox } from "./menu-item-checkbox";

export function FiltersMaterialsScreen(): JSX.Element {
    const { label, options } = useFilter("material");
    const { isActive } = useActiveFilters();
    const { onOptionChange } = useFilterSync();
    const { onFilterBack } = useFilterBack();

    return (
        <FilterDialogScreen title={label} onBack={() => onFilterBack("/")}>
            <ul>
                {options.map((option) => (
                    <li key={option.id}>
                        <MenuItemCheckbox
                            label={option.label}
                            onChange={() => onOptionChange(option)}
                            checked={isActive(option)}
                            to={option.url}
                        />
                    </li>
                ))}
            </ul>
        </FilterDialogScreen>
    );
}
